export default __webpack_public_path__ + "static/media/features-thumb-1.1249bc5a.png";